import JSZip from 'jszip';

async function generateZip(files: File[], db?: ArrayBuffer) {
  const zip = new JSZip();
  await Promise.all(
    files?.map(async (file) => {
      const arrayBuffer = await file.arrayBuffer();
      zip.file(file.name, arrayBuffer);
    })
  );

  if (db) {
    zip.file('log.db', db);
  }

  const content = await zip.generateAsync({ type: 'blob' });

  return new File([content], 'log.zip', { type: 'application/zip' });
}

export { generateZip };
